module.exports = __webpack_public_path__ + "img/how_to_reg.229173af.svg";